import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { FulfillmentType } from '../../../../../../../enums/fulfillment-type';
import { useEntitiesFulfillmentProperty } from '../../../../../../../hooks/entities/selectors/fulfillments';
import Global from '../../../../../../../store/global-selectors';
import { CopyTrackingNumberMenuItem } from '../../../../../rate-card/read-only/label-actions/copy-tracking';
import { useIsCopyTrackingEnabledForFulfillment } from '../../../../../rate-card/read-only/label-actions/copy-tracking/hooks';
import { PrintLabelMenuItem } from './print-label';
import { VoidShipmentMenuItem } from './void';
import { UndoMarkAsShippedMenuItem } from './undo-mark-as-shipped';
import { SendNotificationsMenuItem } from './send-notification';
import { PrintShipmentManifestMenuItem } from './print-shipment-manifest';
import { useBTEmailExperienceNew } from '../../../../../../../hooks/use-seller-setting';

const LabelDetailsActions = ({ fulfillmentId }) => {
  const trackingNumber = useSelector((state) => {
    const fulfillment = Global.selectEntitiesFulfillmentById(state, {
      fulfillmentId,
    });
    return fulfillment?.trackingInformation?.trackingNumber;
  });

  const fulfillmentType = useEntitiesFulfillmentProperty({
    fulfillmentId,
    property: 'fulfillmentType',
  });
  const isMarkAsShipped = fulfillmentType === FulfillmentType.Manual;

  const isCopyTrackingEnabled = useIsCopyTrackingEnabledForFulfillment(fulfillmentId);
  const enableNewEmailExperience = useBTEmailExperienceNew();

  return (
    <>
      {isMarkAsShipped ? (
        <UndoMarkAsShippedMenuItem fulfillmentId={fulfillmentId} />
      ) : (
        <>
          <PrintLabelMenuItem fulfillmentId={fulfillmentId} />
          <VoidShipmentMenuItem fulfillmentId={fulfillmentId} />
        </>
      )}
      <PrintShipmentManifestMenuItem fulfillmentId={fulfillmentId} />
      {!enableNewEmailExperience && <SendNotificationsMenuItem />}
      <CopyTrackingNumberMenuItem isEnabled={isCopyTrackingEnabled} trackingNumber={trackingNumber} />
    </>
  );
};

export { LabelDetailsActions };

LabelDetailsActions.propTypes = {
  fulfillmentId: PropTypes.string,
};
